import type { RouteObject } from "react-router-dom";
import Layout from "@/components/base/Layout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import ManhuaDetailPage from "@/pages/manhua/page";
import ChapterPage from "@/pages/chapter/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/category/:slug",
        element: <CategoryPage />,
      },
      {
        path: "/manhua/:id",
        element: <ManhuaDetailPage />,
      },
      {
        path: "/manhua/:id/chapter/:chapterNumber",
        element: <ChapterPage />,
      },
      {
        path: "/about",
        element: <AboutPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;